import { Log, useProxyWatch, useTranslation } from "@fanfanlo";
import { Box } from "@mui/material";
import { matrixUser } from "../../../client";
import toast from "react-hot-toast";

const fileLogger = new Log(false, 'im.components.user.profile');
// fileLogger.childrenPaused = true;
export function UserProfile(){
    const {t} = useTranslation('homepage/im/components/user/profile/content');
    const [userId] = useProxyWatch(matrixUser.userData.userInfo, 'loginResponse.user_id', matrixUser.userData.userInfo.loginResponse?.user_id || "");
    const logger = fileLogger.sub(false, 'UserProfile_fn');
    // logger.pause = true;
    logger.log('userId=', userId)
    return (<Box>
        <Box>
            <span>
                <span>
                    ID:
                </span>
                <span>
                    {userId ? 
                    <span onClick={() => {
                        if (userId) {
                            navigator.clipboard.writeText(userId);
                            toast.success(t('UserProfile.id.copied'))
                        }
                    }} style={{ cursor: userId ? 'pointer' : 'default' }}>{userId}</span>
                     : t("UserProfile.notLoggedIn")}
                </span>
            </span>
        </Box>
    </Box>)
}